import { Component, effect, HostListener, inject, input, OnDestroy, OnInit, output, TemplateRef } from '@angular/core';

import { SharedModule } from '../../shared.module';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service';
import { Subscription } from 'rxjs';
import { _CentralPageService } from '../../central-page/services/_central-page.service';
import { AutofocusFormDirective } from 'src/app/infrastructure/directives/autofocus-form.directive';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { AnimationService } from 'src/app/infrastructure/services/loading-services/animation.service';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    standalone: true,
    imports: [
        AutofocusFormDirective,
        SharedModule,
    ],
    providers: [
    ]
})
export class FormComponent 
    implements OnInit, OnDestroy
{
    private __valueChangeSubscr: Subscription;

    protected readonly _animationService = injectRequired(AnimationService);
    protected readonly _loadingPageService = injectRequired(LoadingPageService);
    protected readonly _formModelService = injectRequired(_FormModelService);
    protected readonly _centralPageService = injectRequired(_CentralPageService);
    
    attributes: {[key: string]: any};
    form = this._formModelService.form;
    hasFocused = false;

    autofocus: boolean;
    template$$ = input<TemplateRef<any>>(null, {alias: 'template'});
    reset$$ = input<void>(null, {alias: 'reset'});

    inputAutofocus$$ = input<boolean>(true, {alias: 'autofocus'});
    
    emitOnDirty = output<boolean>({alias: 'onDirty'});
    emitOnEscape = output({alias: 'onEscape'});
    emitOnEnter = output({alias: 'onEnter'});

    @HostListener('document:focusin', ['$event']) onFocusIn(event: FocusEvent) {
        const _target = event.target as HTMLElement | null;
        const _id = _target?.id;

        if (_id) {
            this._formModelService.controlId_focus = _target.id;
        }
    }
    @HostListener('document:focusout') onFocusOut() {
        this._formModelService.controlId_focus = null;
    }

    constructor() {
        effect(() => this.autofocus = this.inputAutofocus$$() && !this._loadingPageService.isLoading$$()); 
    }

    ngOnInit(): void {
        this.__valueChangeSubscr = this.form?.valueChanges.subscribe(() => {
            const dirty = this.form.dirty;
            this._centralPageService.btnSaveData_set({disabled: !dirty || this.form.invalid})
            this.__emit_onDirty(dirty);
        });
    }

    emit_onEnter() {
        this.emitOnEnter.emit();
    }

    private __emit_onDirty(value: boolean) {
        this.emitOnDirty.emit(value);
    }

    ngOnDestroy(): void {
        this.__valueChangeSubscr?.unsubscribe();
    }
}
